import CIMSTable from '../../../../../../../../../components/CIMSTable'
import { useRFITrackerContext } from '../../RFITrackerContext'
import { useColumns } from './hooks/useColumns'
import DisciplineResponseModal from './components/DisciplineResponseModal'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'
import { useCustomRowOptions } from './hooks/useCustomRowOptions'
import DraftSubmitRFIModal from './components/DraftSubmitRFIModal'
import { RevertRFIModal } from './hooks/useCustomRowOptions/components/RevertRFIModal'
import { CSVEntity } from 'shared'
import EditResponseModal from './hooks/useExpandOptions/components/EditResponseModal'

const RFITrackerTable: React.FC = () => {
  const {
    records,
    refetch,
    fetching,
    disciplineResponseModal: {
      toggle: toggleDisciplineResponseModal,
      ...disciplineResponseModal
    },
    draftSubmitModal: { toggle: toggleDraftSubmitModal, ...draftSubmitModal },
    revertRFIModal: { toggle: toggleRevertModal, ...revertRFIModal },
    editResponseModal: {
      toggle: toggleEditResponseModal,
      ...editResponseModal
    },
  } = useRFITrackerContext()

  const columns = useColumns()
  const createOptions = useCreateOptions()
  const editOptions = useEditOptions()
  const removeOptions = useRemoveOptions()
  const restoreOptions = useRestoreOptions()
  const customOptions = useCustomRowOptions()
  const expand = useExpandOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      columns={columns}
      records={records}
      actions={{
        header: {
          csv: CSVEntity.RequestForInformation,
          create: createOptions,
          onReload: refetch,
          deepLinkKey: 'id',
        },
        row: {
          edit: editOptions,
          remove: removeOptions,
          restore: restoreOptions,
          custom: customOptions,
        },
      }}
      expand={expand}
    >
      <DisciplineResponseModal
        onClose={() => toggleDisciplineResponseModal(null)}
        {...disciplineResponseModal}
      />
      <DraftSubmitRFIModal
        onClose={() => toggleDraftSubmitModal(null)}
        {...draftSubmitModal}
      />
      <RevertRFIModal
        onClose={() => toggleRevertModal(null)}
        {...revertRFIModal}
      />
      <EditResponseModal
        onClose={() => toggleEditResponseModal(null)}
        {...editResponseModal}
      />
    </CIMSTable>
  )
}

export default RFITrackerTable
